module.exports = __webpack_public_path__ + "img/middleware-dashboard.b07e1820.svg";